import { z } from 'zod';
import { PartnerUserAuthorizationRole } from '../../enums/Partner';
import { BaseSchema } from '../BaseSchema';
import { UserSchema } from '../User';
export var PartnerUserAuthorizationSchema = BaseSchema.extend({
    partner: z.union([z.string(), z.any()]),
    role: z.nativeEnum(PartnerUserAuthorizationRole),
    inviteToken: z.string().optional(),
    user: z.union([z.string(), UserSchema]),
    parentPartner: z.union([z.string(), z.any()]).optional()
});
